import { PatientsState, SearchPatient } from './types';

import { PatientsAction } from './actions';
import { ReduxAction } from '../core';

const initialState: PatientsState = {
  searchText: '',
  isSearching: false,
};

export function patientsReducer(state: PatientsState = initialState, action: ReduxAction<any>): PatientsState {
  switch (action.type) {
    case PatientsAction.PATIENT_SEARCH_CHANGED:
      return {
        ...state,
        searchText: action.data as string,
      };

    case PatientsAction.PATIENT_SET_SEARCHING:
      return {
        ...state,
        isSearching: action.data as boolean,
      };

    case PatientsAction.PATIENT_SET_PATIENTS:
      return {
        ...state,
        patients: action.data as SearchPatient[],
      };

    default:
      return state;
  }
}
